import React, {useEffect, useState, useRef} from 'react';
import {Card, Container, Row, Col, Collapse, Form, Tab, Nav, Table, Button, Modal} from 'react-bootstrap';
import {useNavigate} from 'react-router-dom';
import {FaChevronDown, FaChevronUp} from 'react-icons/fa';
import {fetchGetData, fetchPostData} from "./api";
import {AgGridReact} from 'ag-grid-react';
import {ClientSideRowModelModule} from 'ag-grid-community';
import {ValidationModule} from 'ag-grid-community';
import {ModuleRegistry} from 'ag-grid-community';
import {PaginationModule} from 'ag-grid-community';
import {CsvExportModule} from 'ag-grid-community';
import moment from 'moment';

ModuleRegistry.registerModules([PaginationModule, CsvExportModule]);

const TrackEmployee = () => {
    const [companyName, setCompanyName] = useState('');
    const [jobEmployer, setEmployer] = useState([]);
    const [vacancyName, setVacancyName] = useState('');
    const [jobVacancy, setVacancy] = useState([]);
    const [open1, setOpen1] = useState(false);
    const [open2, setOpen2] = useState(false);
    const [open3, setOpen3] = useState(false);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    // const [excelData, setExcelData] = useState([]);
    const tabIndex = {
        'tab1': [],
        'tab2': [],
        'tab3': [],
        'tab4': [],
        'tab5': [],
        'tab6': [],
    }
    const [excelData, setExcelData] = useState(tabIndex);
    const [lastClickedRowId, setLastClickedRowId] = useState(null);
    const [user, setUserData] = useState({
        name: "John Doe",
        email: "john.doe@example.com",
        phone: "+1234567890",
    });

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [rowData, setRowData] = useState([
        {make: 'Toyota', model: 'Corolla', price: 35000},
        {make: 'Ford', model: 'Focus', price: 27000},
        {make: 'BMW', model: 'X5', price: 65000},
    ]);

    const columns = [
        {headerName: "Make", field: "make"},
        {headerName: "Model", field: "model"},
        {headerName: "Price", field: "price"},
        {
            headerName: 'Actions',
            field: 'actions',
            cellRenderer: (params) => (
                <div>
                    <Button className="mb-3" variant="warning"
                            onClick={() => handleEdit(params.data)}>Edit</Button>&nbsp;
                    <Button className="mb-3" variant="danger" onClick={() => handleDelete(params.data)}>Delete</Button>
                </div>
            ),
        },
    ];
    const handleEdit = (data) => {
        alert(`Editing: ${JSON.stringify(data)}`);
    };

    const handleDelete = (data) => {
        alert(`Deleting: ${JSON.stringify(data)}`);
    };

    const handleView = async (data, index) => {
        // alert(`Employee ID: ${JSON.stringify(data)}`);
        // alert(`Employee ID: ${data.employeeid}`);
        const defaultUser = {
            user_id: null,
            user_name: '',
            mobile: '',
            qualification: '',
            skills: '',
            location: '',
            salary_preference: '',
            preferred_jobs: '',
            preferred_category: '',
            jobTitleIds: '',
            qualificationIds: '',
            gender: null,
            native_location: null,
            regNow: null,
            last_login: null,
            responseGetAt: null
        };
        setUserData(defaultUser)
        try {
            const [userData] = await Promise.all([
                fetchGetData('/employee/get/employee', {id: data.employeeid})
            ]);
            const user = {
                name: data.employeename,
                email: data.employername,
                phone: data.to,
            };
            if (userData.data.length > 0) {
                userData.data[0].last_login = moment(data.last_login).format('DD-MM-YYYY, h:mm:ss A')
                userData.data[0].responseGetAt = moment(data.responseGetAt).format('DD-MM-YYYY, h:mm:ss A')
                userData.data[0].reference = data._id
                userData.data[0].status = data.status
                userData.data[0].message = data.message
                userData.data[0].index = index
                setUserData(userData.data[0])
            } else {
                const defaultUser = {
                    user_id: null,
                    user_name: '',
                    mobile: '',
                    qualification: '',
                    skills: '',
                    location: '',
                    salary_preference: '',
                    preferred_jobs: '',
                    preferred_category: '',
                    jobTitleIds: '',
                    qualificationIds: '',
                    gender: null,
                    native_location: null,
                    regNow: null,
                    last_login: null,
                    responseGetAt: null
                };
                setUserData(defaultUser)
            }
            handleShow()
        } catch (error) {
            console.error('Error fetching data:', error);
            alert(error.message())
        }
    };
    const columnsStaffing = [
        {headerName: "S. No", valueGetter: (params) => params.node.rowIndex + 1, width: 80},
        {
            headerName: 'Actions',
            field: 'actions',
            // cellRenderer: (params) => (
            //     <div>
            //         {/*<Button className="mb-3" variant="warning" onClick={() => handleEdit(params.data)}>Edit</Button>&nbsp;*/}
            //         {/*<Button className="mb-3" variant="danger" onClick={() => handleDelete(params.data)}>Delete</Button>*/}
            //         <Button className="mb-3" variant="warning"
            //                 onClick={() => handleView(params.data)}>View</Button>&nbsp;
            //     </div>
            // ),
            cellRenderer: (params) => (
                <div>
                    <Button
                        className={`mb-3 ${params.data._id === lastClickedRowId ? "highlighted-button" : ""}`}
                        variant="primary" // Default color
                        onClick={() => {
                            setLastClickedRowId(params.data._id);// Track last clicked row
                            handleView(params.data, params.node.rowIndex); // Handle click
                        }}
                    >
                        View
                    </Button>
                </div>
            ),
        },
        {headerName: "Employee id", field: "employeeid"},
        {headerName: "Mobile", field: "to"},
        {headerName: "Employee name", field: "employeename"},
        {headerName: "Last active", field: "last_login"},
        {headerName: "Interest Received At", field: "responseGetAt"},
        {headerName: "Message status", field: "status"},
        {headerName: "Message", field: "message"},
    ];

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                // const [districtRes, jobEmployer] = await Promise.all([
                //     fetchGetData('/employer/get/employees/interest', { id: '676038c7ce995fb0ad12c64e' }), // Replace with actual API
                //     fetchGetData('/master/get/employer/new')
                // ]);
                // setExcelData(districtRes.data);
                // setEmployer(jobEmployer.data);

                const [jobEmployer] = await Promise.all([
                    fetchGetData('/master/get/employer/new')
                ]);
                setEmployer(jobEmployer.data);
            } catch (error) {
                console.error('Error fetching data:', error);
                setEmployer([]);
            }
            setLoading(true)
            try {
                const [jobVacancy] = await Promise.all([
                    fetchGetData('/employer/get/employees/interest', {id: "", tab: "tab2", employer: ""})
                ]);
                setExcelData((prevData) => ({
                    ...prevData,  // Preserve other tab data
                    ['tab2']: jobVacancy.data, // Update only the selected tab
                }));
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false)
            }
        };

        fetchInitialData();
    }, []);
    const fetchData = async (selectedEmployerId) => {
        try {
            const [jobVacancy] = await Promise.all([
                fetchGetData('/employer/get/employer/vacancy', {id: selectedEmployerId})
            ]);
            setVacancy(jobVacancy.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
        setLoading(true)
        try {
            const [jobVacancy] = await Promise.all([
                fetchGetData('/employer/get/employees/interest', {id: "", tab: activeTab, employer: selectedEmployerId})
            ]);
            setExcelData((prevData) => ({
                ...prevData,  // Preserve other tab data
                ['tab2']: jobVacancy.data, // Update only the selected tab
            }));
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false)
        }
    };

    const handleSelectEmployerChange = (e) => {
        const selectedEmployerId = e.target.value;
        setCompanyName(selectedEmployerId)
        setExcelData(tabIndex);
        if (selectedEmployerId) {
            fetchData(selectedEmployerId); // Fetch data based on selected employer
        } else {
            setVacancy([]);
        }
    };
    const handleSelectVacanyChange = async (e) => {
        setExcelData(tabIndex);
        setLoading(true)
        const selectedVacancyId = e.target.value;
        setVacancyName(selectedVacancyId)
        setLastClickedRowId(null)
        if (selectedVacancyId || true) {
            try {
                const [jobVacancy] = await Promise.all([
                    fetchGetData('/employer/get/employees/interest', {id: selectedVacancyId, tab: activeTab, employer: companyName})
                ]);
                // setExcelData(jobVacancy.data);
                // setExcelData({
                //     tab1: [], // New data for tab1
                //     tab2: jobVacancy.data, // Keep other tabs empty or define their data
                //     tab3: [],
                //     tab4: [],
                // });
                setExcelData((prevData) => ({
                    ...prevData,  // Preserve other tab data
                    [activeTab]: jobVacancy.data, // Update only the selected tab
                }));
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false)
            }
        } else {
            setExcelData(tabIndex);
            setLoading(false)
        }
    };

    const gridRef1 = useRef(null);
    const gridRef2 = useRef(null);
    const gridRef3 = useRef(null);
    const gridRef4 = useRef(null);
    const gridRef5 = useRef(null);
    const gridRef6 = useRef(null);

    const handleDownload = () => {
        const tabIndex = {
            'tab1': "Targeted employees",
            'tab2': "Interested Employees",
            'tab3': "Willing to attend an interview",
            'tab4': "Interview attended",
            'tab5': "Selected employees",
            'tab6': "Interest revoked",
        }
        const selectedEmployer = jobEmployer.find(role => role.id.toString() === companyName)?.english;
        const selectedVacancy = jobVacancy.find(role => role._id.toString() === vacancyName)?.jobtitle;
        const excelFileName =
            tabIndex[activeTab] + '-' +
            (selectedEmployer ? selectedEmployer : "All companies") + '-' +
            (selectedVacancy ? selectedVacancy : "All vacancies") + '-' +
            new Date().toLocaleTimeString() + '.csv';

        // console.log(excelFileName);
        const optionsCSV = {
            // fileName: 'my-data-' + new Date().toISOString() + '.csv',
            // fileName: selectedEmployer + '-' + selectedVacancy + '-' + new Date().toLocaleTimeString() + '.csv',
            fileName: excelFileName,
            // fileName: tabIndex[activeTab] + '-' + (selectedEmployer) ? selectedEmployer : "All companies" + '-' + (selectedVacancy) ? selectedVacancy : "All vacancies" + '-' + new Date().toLocaleTimeString() + '.csv',
            // columnKeys: ['name', 'age'], // Only include specific columns
            // columnKeys: ['_id', 'employeename', 'employername', 'message', 'createdAt'],
            // columnKeys: columnsStaffing.map(col => col.field),
            // processCellCallback: (params) => {
            //     if (typeof params.value === 'number') {
            //         return params.value.toLocaleString('fullwide', { useGrouping: false });
            //     }
            //     // Custom processing for cell values
            //     return params.value.toUpperCase();
            // },
        };
        let gridRef;
        switch (activeTab) {
            case 'tab1':
                gridRef = gridRef1;
                break;
            case 'tab2':
                gridRef = gridRef2;
                break;
            case 'tab3':
                gridRef = gridRef3;
                break;
            case 'tab4':
                gridRef = gridRef4;
                break;
            case 'tab5':
                gridRef = gridRef5;
                break;
            default:
                gridRef = gridRef6;
                break;
        }
        gridRef.current.api.exportDataAsCsv(optionsCSV);
    };
    const [activeTab, setActiveTab] = useState("tab2");

    const handleTabSelect = async (selectedKey) => {
        tabIndex['tab1'] = excelData['tab1']
        setExcelData(tabIndex);
        setActiveTab(selectedKey);
        console.log("Active tab index:", selectedKey); // alert(activeTab + " - " + selectedKey)
        setLoading(true)
        const selectedVacancyId = vacancyName;
        setLastClickedRowId(null)
        if (selectedVacancyId || true) {
            if (excelData[selectedKey].length > 0) {
                setLoading(false)
            } else {
                try {
                    const [jobVacancy] = await Promise.all([
                        fetchGetData('/employer/get/employees/interest', {id: selectedVacancyId, tab: selectedKey, employer: companyName})
                    ]);
                    // setExcelData(jobVacancy.data);
                    console.log("activeTab: ", selectedKey)
                    // setExcelData({
                    //     [selectedKey]: jobVacancy.data
                    // });
                    setExcelData((prevData) => ({
                        ...prevData,  // Preserve other tab data
                        [selectedKey]: jobVacancy.data, // Update only the selected tab
                    }));
                } catch (error) {
                    console.error('Error fetching data:', error);
                } finally {
                    setLoading(false)
                }
            }
        } else {
            setExcelData(tabIndex);
            setLoading(false)
        }
    };

    const setFollowUpAction = async (action, data, reason = "") => {
        if (action === "விருப்பமில்லை") {
            reason = prompt("Please provide a reason:");
            if (!reason) return; // Stop execution if the user cancels or enters an empty reason
        }
        if (window.confirm("You are about to move this to the " + action + " list")) {
            // alert(`setFollowUpAction: ${action} ${JSON.stringify(data)}`);
            setLoading(true);
            try {
                data.action = action
                data.reason = reason
                const response = await fetchPostData('/employer/set/followp/action', data, {
                    'Content-Type': 'application/json',
                });

                if (response.success) {
                    handleClose()
                    const index = data.index
                    // alert("Moved to " + response.message + " list");
                    alert("Moved to " + action + " list");
                    excelData[activeTab][index] = null;
                    setExcelData((prevData) => ({
                        ...prevData,  // Preserve other tab data
                        [activeTab]: excelData[activeTab].filter(item => item !== null), // Update only the selected tab
                    }));
                } else {
                    alert(response.message);
                }
            } catch (error) {
                console.error('Error submitting the form:', error);
                alert(error.message || "Soemthing went wrong!");
            } finally {
                handleClose()
                setLoading(false);
            }
        }
    };
    return (
        <Container className="mt-5">
            <Row>
                {/* Column 1: Checkboxes (col-3) */}
                <Col md={3}>
                    {/* Collapsible Section 1 */}
                    <Card className="mb-3">
                        <Button className="mb-3" variant="primary">Filter
                            employee</Button>
                        <Form.Group controlId="companyName" className="p-1">
                            <Form.Label>Choose employer</Form.Label>
                            <Form.Select
                                value={companyName}
                                onChange={handleSelectEmployerChange}
                                required
                            >
                                <option value="">Choose employer</option>
                                {jobEmployer.map(role => (
                                    <option key={role.id} value={role.id}>
                                        {role.english}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        <Form.Group controlId="vacancyName" className="p-1">
                            <Form.Label>Choose vacancy</Form.Label>
                            <Form.Select
                                value={vacancyName}
                                onChange={handleSelectVacanyChange}
                                required
                            >
                                <option value="">Choose vacancy</option>
                                {jobVacancy.map(role => (
                                    <option key={role._id} value={role._id}>
                                        {role.jobtitle || 'no title found'} [{role.count}] - {role.createdAt}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        {/*<Card.Header onClick={() => setOpen1(!open1)} style={{cursor: 'pointer'}}>*/}
                        {/*    Filter Employees 1 <span className="float-end">{open1 ? <FaChevronUp/> :*/}
                        {/*    <FaChevronDown/>}</span>*/}
                        {/*</Card.Header>*/}
                        {/*<Collapse in={open1}>*/}
                        {/*    <div>*/}
                        {/*        <Card.Body>*/}
                        {/*            <Form>*/}
                        {/*                <Form.Check type="checkbox" label="Department A"/>*/}
                        {/*                <Form.Check type="checkbox" label="Department B"/>*/}
                        {/*                <Form.Check type="checkbox" label="Department C"/>*/}
                        {/*            </Form>*/}
                        {/*        </Card.Body>*/}
                        {/*    </div>*/}
                        {/*</Collapse>*/}
                    </Card>

                    {/* Collapsible Section 2 */}
                    {/*<Card className="mb-3">*/}
                    {/*    <Card.Header onClick={() => setOpen2(!open2)} style={{cursor: 'pointer'}}>*/}
                    {/*        Filter Employees 2 <span className="float-end">{open2 ? <FaChevronUp/> :*/}
                    {/*        <FaChevronDown/>}</span>*/}
                    {/*    </Card.Header>*/}
                    {/*    <Collapse in={open2}>*/}
                    {/*        <div>*/}
                    {/*            <Card.Body>*/}
                    {/*                <Form>*/}
                    {/*                    <Form.Check type="checkbox" label="Department A"/>*/}
                    {/*                    <Form.Check type="checkbox" label="Department B"/>*/}
                    {/*                    <Form.Check type="checkbox" label="Department C"/>*/}
                    {/*                </Form>*/}
                    {/*            </Card.Body>*/}
                    {/*        </div>*/}
                    {/*    </Collapse>*/}
                    {/*</Card>*/}

                    {/* Collapsible Section 3 */}
                    {/*<Card className="mb-3">*/}
                    {/*    <Card.Header onClick={() => setOpen3(!open3)} style={{cursor: 'pointer'}}>*/}
                    {/*        Filter Employees 3 <span className="float-end">{open3 ? <FaChevronUp/> :*/}
                    {/*        <FaChevronDown/>}</span>*/}
                    {/*    </Card.Header>*/}
                    {/*    <Collapse in={open3}>*/}
                    {/*        <div>*/}
                    {/*            <Card.Body>*/}
                    {/*                <Form>*/}
                    {/*                    <Form.Check type="checkbox" label="Department A"/>*/}
                    {/*                    <Form.Check type="checkbox" label="Department B"/>*/}
                    {/*                    <Form.Check type="checkbox" label="Department C"/>*/}
                    {/*                </Form>*/}
                    {/*            </Card.Body>*/}
                    {/*        </div>*/}
                    {/*    </Collapse>*/}
                    {/*</Card>*/}
                </Col>

                {/* Column 2: Tabs and Table (col-9) */}
                <Col md={9}>
                    <Tab.Container defaultActiveKey="tab2">
                        <Card>
                            <Card.Header>
                                <Nav variant="tabs" onSelect={handleTabSelect}>
                                    <Nav.Item>
                                        {/*<Nav.Link eventKey="tab1">Interested Employees ({excelData.length})</Nav.Link>*/}
                                        <Nav.Link eventKey="tab1">
                                            Targeted employees{" "}
                                            {excelData['tab1'].length > 0 && (
                                                <span
                                                    style={{
                                                        color: "red",
                                                        fontWeight: 500
                                                    }}>({excelData['tab1'].length})</span>
                                            )}
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        {/*<Nav.Link eventKey="tab1">Interested Employees ({excelData.length})</Nav.Link>*/}
                                        <Nav.Link eventKey="tab2">
                                            Interested Employees{" "}
                                            {excelData['tab2'].length > 0 && (
                                                <span
                                                    style={{
                                                        color: "red",
                                                        fontWeight: 500
                                                    }}>({excelData['tab2'].length})</span>
                                            )}
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="tab3">Willing to attend an interview{" "}
                                            {excelData['tab3'].length > 0 && (
                                                <span
                                                    style={{
                                                        color: "red",
                                                        fontWeight: 500
                                                    }}>({excelData['tab3'].length})</span>
                                            )}</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="tab4">Interview attended{" "}
                                            {excelData['tab4'].length > 0 && (
                                                <span
                                                    style={{
                                                        color: "red",
                                                        fontWeight: 500
                                                    }}>({excelData['tab4'].length})</span>
                                            )}</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="tab5">Selected employees{" "}
                                            {excelData['tab5'].length > 0 && (
                                                <span
                                                    style={{
                                                        color: "red",
                                                        fontWeight: 500
                                                    }}>({excelData['tab5'].length})</span>
                                            )}</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="tab6">Interest revoked{" "}
                                            {excelData['tab6'].length > 0 && (
                                                <span
                                                    style={{
                                                        color: "red",
                                                        fontWeight: 500
                                                    }}>({excelData['tab6'].length})</span>
                                            )}</Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </Card.Header>

                            <Card.Body>
                                <Tab.Content>
                                    <Tab.Pane eventKey="tab1">
                                        {excelData['tab1'].length > 0 && (
                                            <Button className="mb-3" variant="primary" onClick={handleDownload}>
                                                Download CSV
                                            </Button>
                                        )}
                                        <div className="ag-theme-alpine" style={{height: 400, width: '100%'}}>
                                            <style>
                                                {`
          .highlighted-button {
            background-color: #f0ad4e !important; /* Custom highlight color (e.g., orange) */
            border-color: #eea236;
          }
        `}
                                            </style>
                                            <AgGridReact
                                                ref={gridRef1}
                                                columnDefs={columnsStaffing}
                                                rowData={excelData['tab1']}
                                                pagination={true}
                                                domLayout="autoHeight"
                                                modules={[ClientSideRowModelModule]}
                                                modules={[ValidationModule, ClientSideRowModelModule]}
                                                loading={loading}
                                            />
                                        </div>
                                    </Tab.Pane>
                                    {/* Tab 1 content */}
                                    <Tab.Pane eventKey="tab2">
                                        {/*{excelData.length > 0 && (*/}
                                        {/*    <Table striped bordered hover>*/}
                                        {/*        <thead>*/}
                                        {/*        <tr>*/}
                                        {/*            {Object.keys(excelData[0]).map((key) => (*/}
                                        {/*                <th key={key}>{key}</th>*/}
                                        {/*            ))}*/}
                                        {/*        </tr>*/}
                                        {/*        </thead>*/}
                                        {/*        <tbody>*/}
                                        {/*        {excelData.length > 0 ? (*/}
                                        {/*            excelData.map((row, index) => (*/}
                                        {/*                <tr key={index}>*/}
                                        {/*                    {Object.values(row).map((value, i) => (*/}
                                        {/*                        <td key={i}>*/}
                                        {/*                            {typeof value === 'object' && value !== null*/}
                                        {/*                                ? JSON.stringify(value) // Convert objects to strings*/}
                                        {/*                                : value}*/}
                                        {/*                        </td>*/}
                                        {/*                    ))}*/}
                                        {/*                </tr>*/}
                                        {/*            ))*/}
                                        {/*        ) : (*/}
                                        {/*            <tr>*/}
                                        {/*                <td colSpan="100%">No data available</td>*/}
                                        {/*            </tr>*/}
                                        {/*        )}*/}
                                        {/*        </tbody>*/}
                                        {/*    </Table>*/}
                                        {/*)}*/}
                                        {excelData['tab2'].length > 0 && (
                                            <Button className="mb-3" variant="primary" onClick={handleDownload}>
                                                Download CSV
                                            </Button>
                                        )}
                                        <div className="ag-theme-alpine" style={{height: 400, width: '100%'}}>
                                            <style>
                                                {`
          .highlighted-button {
            background-color: #f0ad4e !important; /* Custom highlight color (e.g., orange) */
            border-color: #eea236;
          }
        `}
                                            </style>
                                            <AgGridReact
                                                ref={gridRef2}
                                                columnDefs={columnsStaffing}
                                                rowData={excelData['tab2']}
                                                pagination={true}
                                                domLayout="autoHeight"
                                                modules={[ClientSideRowModelModule]}
                                                modules={[ValidationModule, ClientSideRowModelModule]}
                                                loading={loading}
                                            />
                                        </div>
                                    </Tab.Pane>

                                    {/* Tab 2 content */}
                                    <Tab.Pane eventKey="tab3">
                                        {excelData['tab3'].length > 0 && (
                                            <Button className="mb-3" variant="primary" onClick={handleDownload}>
                                                Download CSV
                                            </Button>
                                        )}
                                        <div className="ag-theme-alpine" style={{height: 400, width: '100%'}}>
                                            <style>
                                                {`
          .highlighted-button {
            background-color: #f0ad4e !important; /* Custom highlight color (e.g., orange) */
            border-color: #eea236;
          }
        `}
                                            </style>
                                            <AgGridReact
                                                ref={gridRef3}
                                                columnDefs={columnsStaffing}
                                                rowData={excelData['tab3']}
                                                pagination={true}
                                                domLayout="autoHeight"
                                                modules={[ClientSideRowModelModule]}
                                                modules={[ValidationModule, ClientSideRowModelModule]}
                                                loading={loading}
                                            />
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="tab4">
                                        {excelData['tab4'].length > 0 && (
                                            <Button className="mb-3" variant="primary" onClick={handleDownload}>
                                                Download CSV
                                            </Button>
                                        )}
                                        <div className="ag-theme-alpine" style={{height: 400, width: '100%'}}>
                                            <style>
                                                {`
          .highlighted-button {
            background-color: #f0ad4e !important; /* Custom highlight color (e.g., orange) */
            border-color: #eea236;
          }
        `}
                                            </style>
                                            <AgGridReact
                                                ref={gridRef4}
                                                columnDefs={columnsStaffing}
                                                rowData={excelData['tab4']}
                                                pagination={true}
                                                domLayout="autoHeight"
                                                modules={[ClientSideRowModelModule]}
                                                modules={[ValidationModule, ClientSideRowModelModule]}
                                                loading={loading}
                                            />
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="tab5">
                                        {excelData['tab5'].length > 0 && (
                                            <Button className="mb-3" variant="primary" onClick={handleDownload}>
                                                Download CSV
                                            </Button>
                                        )}
                                        <div className="ag-theme-alpine" style={{height: 400, width: '100%'}}>
                                            <style>
                                                {`
          .highlighted-button {
            background-color: #f0ad4e !important; /* Custom highlight color (e.g., orange) */
            border-color: #eea236;
          }
        `}
                                            </style>
                                            <AgGridReact
                                                ref={gridRef5}
                                                columnDefs={columnsStaffing}
                                                rowData={excelData['tab5']}
                                                pagination={true}
                                                domLayout="autoHeight"
                                                modules={[ClientSideRowModelModule]}
                                                modules={[ValidationModule, ClientSideRowModelModule]}
                                                loading={loading}
                                            />
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="tab6">
                                        {excelData['tab6'].length > 0 && (
                                            <Button className="mb-3" variant="primary" onClick={handleDownload}>
                                                Download CSV
                                            </Button>
                                        )}
                                        <div className="ag-theme-alpine" style={{height: 400, width: '100%'}}>
                                            <style>
                                                {`
          .highlighted-button {
            background-color: #f0ad4e !important; /* Custom highlight color (e.g., orange) */
            border-color: #eea236;
          }
        `}
                                            </style>
                                            <AgGridReact
                                                ref={gridRef6}
                                                columnDefs={columnsStaffing}
                                                rowData={excelData['tab6']}
                                                pagination={true}
                                                domLayout="autoHeight"
                                                modules={[ClientSideRowModelModule]}
                                                modules={[ValidationModule, ClientSideRowModelModule]}
                                                loading={loading}
                                            />
                                        </div>
                                    </Tab.Pane>
                                </Tab.Content>
                            </Card.Body>
                        </Card>
                    </Tab.Container>
                </Col>
            </Row>
            <Modal show={show} onHide={handleClose} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{user.user_name ? decodeURIComponent(user.user_name.replace(/\+/g, ' ')) : 'No Name Available'} - {user.mobile}</Modal.Title>
                </Modal.Header>
                {/*<Modal.Body>*/}
                {/*    This is the content of the modal.*/}
                {/*</Modal.Body>*/}
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-4">
                            <strong>ID:</strong>
                        </div>
                        <div className="col-md-8">{user.user_id}</div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <strong>Name:</strong>
                        </div>
                        <div
                            className="col-md-8">{user.user_name ? decodeURIComponent(user.user_name.replace(/\+/g, ' ')) : 'No Name Available'}</div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-4">
                            <strong>Mobile:</strong>
                        </div>
                        <div className="col-md-8">{user.mobile}</div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-4">
                            <strong>Location:</strong>
                        </div>
                        <div className="col-md-8">{user.location}</div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-4">
                            <strong>Job titles:</strong>
                        </div>
                        <div className="col-md-8">{user.preferred_jobs}</div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-4">
                            <strong>Qualification:</strong>
                        </div>
                        <div className="col-md-8">{user.qualification}</div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-4">
                            <strong>Last Logged In:</strong>
                        </div>
                        <div className="col-md-8">{user.last_login}</div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-4">
                            <strong>Interest received at:</strong>
                        </div>
                        <div className="col-md-8">{user.responseGetAt}</div>
                    </div>
                    {activeTab == 'tab1' && user && (
                        <>
                            <div className="row mt-2">
                                <div className="col-md-4">
                                    <strong>Status:</strong>
                                </div>
                                <div className="col-md-8">{user.status}</div>
                            </div>
                            <div className="row mt-2">
                                <div className="col-md-4">
                                    <strong>Message:</strong>
                                </div>
                                <div className="col-md-8">{user.message}</div>
                            </div>
                        </>
                    )}
                </Modal.Body>
                {activeTab != 'tab1' && user && (
                    <Modal.Footer>
                        {/*<Button variant="secondary" onClick={handleClose}>*/}
                        {/*    Close*/}
                        {/*</Button>*/}
                        {/*<Button variant="warning" onClick={() => setFollowUpAction( 'விருப்பமில்லை', user)}>*/}
                        {/*    விருப்பமில்லை*/}
                        {/*</Button>*/}
                        {activeTab == 'tab2' && user && (
                            <>
                                <Button variant="danger"
                                        onClick={() => setFollowUpAction('block', user, "Blocked manually")}>
                                    Block
                                </Button>
                                <Button variant="warning"
                                        onClick={() => setFollowUpAction('விருப்பமில்லை', user, "Wrongly sent interest")}>
                                    Not interested
                                </Button>
                                <Button variant="success" onClick={() => setFollowUpAction('willing', user, "")}>
                                    Willing to attend an interview
                                </Button>
                            </>
                        )}
                        {activeTab == 'tab3' && user && (
                            <>
                                <Button variant="danger"
                                        onClick={() => setFollowUpAction('block', user, "Blocked manually")}>
                                    Block
                                </Button>
                                <Button variant="info"
                                        onClick={() => setFollowUpAction('விருப்பமில்லை', user, "Could not attend")}>
                                    Could not attend
                                </Button>
                                <Button variant="warning"
                                        onClick={() => setFollowUpAction('block', user, "Interview not attented")}>
                                    Interview not attended
                                </Button>
                                <Button variant="success" onClick={() => setFollowUpAction('interview', user, "")}>
                                    Interview attended
                                </Button>
                            </>
                        )}
                        {activeTab == 'tab4' && user && (
                            <>
                                <Button variant="danger"
                                        onClick={() => setFollowUpAction('block', user, "Blocked manually")}>
                                    Block
                                </Button>
                                <Button variant="success" onClick={() => setFollowUpAction('select', user, "Selected")}>
                                    Selected
                                </Button>
                            </>
                        )}
                    </Modal.Footer>
                )}
            </Modal>
        </Container>
    )
        ;
};

export default TrackEmployee;
